import { render, staticRenderFns } from "./sub_section.vue?vue&type=template&id=29604ecc&scoped=true"
import script from "./sub_section.vue?vue&type=script&lang=js"
export * from "./sub_section.vue?vue&type=script&lang=js"
import style0 from "./sub_section.vue?vue&type=style&index=0&id=29604ecc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29604ecc",
  null
  
)

export default component.exports